import config from 'config';
import { authHeader } from '../_helpers';

export const frequentAddressService = {
    logout,
    getAddress,
    getFrequentAddresses,
    submitAddress,
    deleteAddress,
    addOrUpdateAddress
};

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('token');
}

function getAddress(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${config.apiUrl}/frequent_address/` + id, requestOptions).then(handleResponse);
}

function getFrequentAddresses(formData) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    var queryString = new URLSearchParams(formData).toString();

    return fetch(`${config.apiUrl}/frequent_address` + '?' + queryString, requestOptions).then(handleResponse);
}

function submitAddress(addressData) {
    var headers = authHeader();
    headers['Content-Type'] = 'application/json';
    const requestOptions = {
        crossDomain: true,
        method: 'POST',
        headers: headers,
        body: JSON.stringify(addressData)
    };

    var url = new URL(`${config.apiUrl}/frequent_address`);
    return fetch(url, requestOptions).then(handleResponse);
}

function deleteAddress(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    }

    var url = new URL(`${config.apiUrl}/frequent_address/` + id);

    return fetch(url, requestOptions).then(handleResponse);
}

function addOrUpdateAddress(address) {
    var headers = authHeader();
    headers['Content-Type'] = 'application/json';
    const requestOptions = {
        crossDomain: true,
        method: 'POST',
        headers: headers,
        body: JSON.stringify(address)
    };

    var url = new URL(`${config.apiUrl}/frequent_address/AddOrUpdate`);
    return fetch(url, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                if(response.url !== `${config.apiUrl}/auth/login`)
                    location.reload(true);
            } else if (response.status == 400) {
                return Promise.reject(data);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}